module.exports = __webpack_public_path__ + "img/cartoonHead2-2.6e5f776b.png";